import "./Notification_module.css";
const Notification_module = {
    notificationContainer: "notificationContainer__0b3dc99f9de6b867",
    moreMessages: "moreMessages__0b3dc99f9de6b867",
    moreMessagesTextContainer: "moreMessagesTextContainer__0b3dc99f9de6b867",
    notificationCard: "notificationCard__0b3dc99f9de6b867",
    notificationDescriptionContainer: "notificationDescriptionContainer__0b3dc99f9de6b867",
    notificationHeader: "notificationHeader__0b3dc99f9de6b867",
    notificationIcon: "notificationIcon__0b3dc99f9de6b867",
    notificationBody: "notificationBody__0b3dc99f9de6b867",
    moreMessagesText: "moreMessagesText__0b3dc99f9de6b867",
    notificationDescription: "notificationDescription__0b3dc99f9de6b867",
    notificationTitle: "notificationTitle__0b3dc99f9de6b867",
    cardBody: "cardBody__0b3dc99f9de6b867",
    slideLeftEnter: "slideLeftEnter__0b3dc99f9de6b867",
    slideLeftEnterActive: "slideLeftEnterActive__0b3dc99f9de6b867",
    slideLeftExit: "slideLeftExit__0b3dc99f9de6b867",
    slideLeftExitActive: "slideLeftExitActive__0b3dc99f9de6b867"
};
export { Notification_module as default };
